var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 77,
    viewBox: "0 0 72 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7347 3.93151C33.8348 3.32058 35.0724 3 36.3307 3C37.5891 3 38.8267 3.32058 39.9268 3.93151L67.7579 19.3896C68.3349 19.7104 68.8157 20.1797 69.1504 20.7488C69.4851 21.3179 69.6615 21.9661 69.6615 22.6264V53.124C69.6612 54.4448 69.3077 55.7415 68.6376 56.8797C67.9676 58.018 67.0054 58.9563 65.8507 59.5976L39.9268 74.0039C38.8267 74.6148 37.5891 74.9354 36.3307 74.9354C35.0724 74.9354 33.8348 74.6148 32.7347 74.0039L6.81081 59.5976C5.65667 58.9566 4.6948 58.0189 4.02479 56.8813C3.35478 55.7438 3.00097 54.4479 3 53.1277V22.6264C2.99997 21.9661 3.17644 21.3179 3.51113 20.7488C3.84581 20.1797 4.32655 19.7104 4.90356 19.3896L32.7384 3.93151H32.7347Z",
    stroke: "#92CDDC",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20.4487L36.3307 38.9658M36.3307 38.9658L69.6615 20.4487M36.3307 38.9658V76",
    stroke: "#92CDDC",
    strokeWidth: 4.08,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6655 29.7073L52.9962 11.1902M14.1104 40.1806L25.2206 46.3727",
    stroke: "#92CDDC",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.2613b3da8acf418a4f9513ab8aefe1dd.svg";
export { ForwardRef as ReactComponent };